// extracted by mini-css-extract-plugin
module.exports = {"container":"TdForm_container__1ShFe","header":"TdForm_header__5dfDC","input":"TdForm_input__2luLd","title":"TdForm_title__3Zj8j","item":"TdForm_item__114FH"};